export default __webpack_public_path__ + "static/media/flourmill_slide.1469bb65.jpg";